import React, { useEffect, useState, useRef } from 'react';
import { Button } from 'react-bootstrap';
import Row from "../../../SDFormTemplate/Row";
import Section from '../../../SDFormTemplate/Section';
import Accordion from 'components/Common/Accordion/Accordion';
import Icon from 'components/Icons/Icon';
import { generateRandomId } from 'components/Common/HelperFunctions/generateRandomId';
import { useSelector } from 'react-redux';

function CustomFields({ setInvalidConditions, setFormData }) {
  
  const darkMode = useSelector(state => state.app.darkMode);

  const title = 'Custom Fields';

  const counterRef = useRef(0);

  const [newInputList, setNewInputList] = useState([]);

  useEffect(() => {
    setFormData((prev) => ({
      ...prev,
      custom_fields: {},
    }))
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  useEffect(() => {
    if (newInputList?.length <= 0 && counterRef.current > 0) { counterRef.current = 0 };
  }, [newInputList, counterRef])

  const handleDelete = (id) => {
    setNewInputList((prev) => prev.filter((i) => i.id !== id));
    setFormData((prev) => {
      const { [id]: _, ...rest } = prev.custom_fields ?? "";
      return { ...prev, custom_fields: rest };
    });
  };

  const customFieldSection = newInputList.map((item) => (
    <Section
      key={item.id}
      stateId={item.id}
      deleteEnabled={true}
      deleteMessage='this field'
      onDelete={() => handleDelete(item.id)}
      prefix={`Custom Field ${item.label}`}
      title='custom_fields'
      label={false}
      valueType='object'
      initialValueProp='string'
      placeholder='Enter custom field name here | Empty values will be ignored'
      disableDefaultStyles
      containerStyles='my-2'
      setInvalidConditions={setInvalidConditions}
      setFormData={setFormData}
    />
  ));

  const customFieldsContainer = () => {
    return (
      <div key='custom-field-wrapper' className='d-flex flex-column'>
        <Button
          className='mb-2'
          variant={darkMode ? 'light' : 'primary'}
          onClick={() => {
            counterRef.current += 1;
            setNewInputList((prev) => [
              ...prev,
              { id: generateRandomId(), label: counterRef.current },
            ]);
          }}
        >
          <Icon className='fas fa-plus' />
        </Button>

      <span 
        style={{ 
          border: 'solid 1px lightgray',
          borderRadius: '5px',
          padding: '12px',
        }}
      >
        {newInputList?.length <= 0 ?
          'No Custom Fields'
        :
          customFieldSection
        }
      </span>
      </div>
    )
  }

  return (
    <div key="custom_fields">
      <Row
        key='row_4'
        sections={[
          (index) => (
            <Accordion
              key='accordion_4'
              title={title}
              accordionHeaderSection={true}
              accordionHeaderContents={{
                size: 'md',
                message: 'Create additional data fields for information relevant to your customer.',
              }}
              showNumberInHeader={false}
              headerNumber={index + 1}
              content={[
                customFieldsContainer(),
              ]}
            />
          )
        ]}
      />
    </div>
  )
}

export default CustomFields;
